import { is, forEach, compose, path } from 'ramda'
import { parseTimeZone, getLocalTimeZone, isValidTimeZone } from 'assets/localization'
import { notEmptyOrNil } from 'shared/helpers/functional'

/**
 * API currently maps attribute to question
 * in AnswerService.nextWantedAttribute(SQL statement)
 * if this changes, below ids should be changed accordingly
 */
const attributeExceptions = new Set([4, 5, 103, 104, 152])

export const getHint = (question, user, translate, formatNumber) => {
  const {
    id,
    minimum,
    maximum,
    typeId,
  } = question

  if (attributeExceptions.has(id)) return ''

  const { timeZone } = user
  const minMaxTuple = [minimum, maximum]
  const [hasMin, hasMax] = minMaxTuple.map(is(Number))
  // NOTE: extra function is used to avoid passing more args to formatNumber
  const [min, max] = minMaxTuple.map(n => formatNumber(n))
  const hasRange = hasMin && hasMax
  const hasExact = hasRange && (minimum === maximum)

  switch (typeId) {
    case 3: return translate(...(
      hasExact ? ['question.hint.multi_exact', {num: min}] :
      hasRange ? ['question.hint.multi_range', {min, max}] :
      hasMin ? ['question.hint.multi_min', {min}] :
      hasMax ? ['question.hint.multi_max', {max}] :
      ['']
    ))
    case 6:
    case 15: return translate(...(
      hasRange ? ['question.hint.numeric_range', {min, max}] :
      hasMin ? ['question.hint.numeric_min', {min}] :
      hasMax ? ['question.hint.numeric_max', {max}] :
      ['']
    ))
    case 8: return translate('question.hint.forced_rating')
    case 9: return translate('question.hint.numeric_dist', {max})
    case 11: return translate(...(
      hasExact ? ['question.hint.matrix_exact', {num: min}] :
      hasRange ? ['question.hint.matrix_range', {min, max}] :
      hasMin ? ['question.hint.matrix_min', {min}] :
      hasMax ? ['question.hint.matrix_max', {max}] :
      ['']
    ))
    case 13: return translate('question.hint.scheduler', {
      timeZone: isValidTimeZone(timeZone) ? parseTimeZone(timeZone) : getLocalTimeZone(),
    })
    default: return ''
  }
}

const stripPlaceholders = txt => txt.replace(/{{(.*?)}}/gm, '$1')

const formatQuestionOrChoiceText = (text, fixTables) => {
  const frag = document.createElement('div')
  frag.innerHTML = stripPlaceholders(text)

  if (fixTables) {
    forEach(el => {
      el.style.width = '100%'
    }, frag.querySelectorAll('table, tr'))
  }
  forEach(el => {
    if (/unanswered/.test(el.className)) {
      el.innerHTML = `{ answer from ${el.innerText} }`
    }
  }, frag.querySelectorAll('.wysiwyg-question-answer-placeholder'))

  return frag.innerHTML
}

export const formatQuestionText = text => formatQuestionOrChoiceText(text, true)
export const formatChoiceText = text => formatQuestionOrChoiceText(text, false)

export const isFollowup = compose(notEmptyOrNil, path(['deltas', 'initialQuestions']))
